
import styled from "styled-components"
import {GoCheck} from "react-icons/go"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { updateRouteItem } from "../../../../../features/addLoad/addLoadSlice"
import { useEffect } from "react"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    .box{
        width: 22px;
        height: 22px;
        border-radius: 3px;
        border: 2px solid ${({theme}) => theme.mainTextColor};

        display: flex;
        justify-content: center;
        align-items: center;

        .check-icon{
            font-size: 1.2rem;
            color:#000;
        }

    }

    .label{
        font-size: 12px;
        font-weight: var(--font-weight-xl);
    }

`


const YuklemeAllTimeCheckbox = ({data, name, isRequired}) => {

    const dispatch = useDispatch()

    const handleCheck = (checked) => {

        if(!checked){
            dispatch(updateRouteItem({
                id: data.id,
                saatAllTime: !checked,
                saatBaslangic: "00:00",
                saatBitis: "00:00"
            }))
        }
        else{
            dispatch(updateRouteItem({
                id: data.id,
                saatAllTime: !checked,
                saatBaslangic: "",
                saatBitis: ""
            }))
        }
    }

    useEffect(() => {
        if(data.saatBaslangic !== "00:00" || data.saatBitis !== "00:00"){
            dispatch(updateRouteItem({
                id: data.id,
                saatAllTime: false,
            }))
        }
        else{
            dispatch(updateRouteItem({
                id: data.id,
                saatAllTime: true,
            }))
        }
    },[data.saatBaslangic, data.saatBitis])

  return (
    <Container>
        <div className="box" onClick={() => handleCheck(data.saatAllTime)}>{data.saatAllTime && <GoCheck className="check-icon"/>}</div>
        <div className="label">24 Saat Yükleme Yapılır</div>
    </Container>
  )
}

export default YuklemeAllTimeCheckbox